import {mParticleLogin, mParticleEventType} from '@treatwell/ui';
import {httpGetJson} from '../../../../../api/http';
import {SDKEventAttrs} from '@mparticle/web-sdk';
import {trackEvent} from '../../../../../tracking/mParticle';
import {api} from '../../../../../../config';
import {RainbowMeResponse} from '../../../../../store/models/user/types';

export function trackMParticleRegister(
  country: string,
  hasMarketingOptedIn = false
) {
  return httpGetJson<RainbowMeResponse>({
    path: `${api.rainbowApiClient}/me/information`,
  })
    .then((user) => {
      if (user.loginStatus === 'account_authenticated') {
        mParticleLogin({
          userIdentities: {
            customerid: String(user.accountId),
            email: user.email,
          },
        });
      }
    })
    .catch(() => {})
    .finally(() => {
      trackEvent({
        eventName: 'user_registered',
        eventAttributes: {
          country,
          platform: 'web',
          authentication_method: 'password',
          has_marketing_opted_in: hasMarketingOptedIn,
          trigger_context: 'login',
        },
        eventType: mParticleEventType.UserPreference,
      });
    });
}

export function trackRegisterSubmitted({
  country,
  isMarketingOptedIn,
  isWebMobile,
  errorMessage,
}: {
  country: string;
  isMarketingOptedIn: boolean;
  isWebMobile: boolean;
  errorMessage?: string;
}) {
  const attributes: SDKEventAttrs = {
    country,
    platform: 'web',
    is_web_mobile: isWebMobile,
    is_marketing_opted_in: isMarketingOptedIn,
  };

  if (errorMessage) {
    attributes.error_message = errorMessage;
  }

  trackEvent({
    eventName: 'signup_submitted',
    eventType: mParticleEventType.Other,
    eventAttributes: attributes,
  });
}
